import coreAPIService from './coreAPIService';
import { CTW_API_ENDPOINT } from '../utils';
import { OrganizationDetails, OrganizationUpdateData, ManagerAssignmentRequest, OrganizationSummary, GrantAccessRequest, WabaAccount, OrgUser, AddOrgResponse, AddUserRequest, AddUserResponse, FetchUsersResponse, UpdateUserAccessRequest, UpdateUserAccessResponse, FetchOrgUsersResponse } from '../interfaces/orgManagement';
import { WabaDetailsResponse } from '../interfaces/setup';

class OrgManagementService {
    async getOrgDetails(orgId: string): Promise<OrganizationDetails> {
        // const response = await coreAPIService.get<any>(
        //     CT_API_ENDPOINT,
        //     `organizations/${orgId}`
        // );
        // return response.data;

        return {
            orgId: orgId,
            orgName: 'Mock Account',
            orgType: 'self_served',
            managerOrgId: undefined,
            address: '123 Mock Street, Mock City',
            contactEmail: 'contact@mockorg.com',
            contactPhone: '+1 555-0123',
            website: 'https://www.mockorg.com',
            createdAt: '2023-01-01T00:00:00Z'
        };
    }

    async updateOrgDetails(orgId: string, data: OrganizationUpdateData): Promise<void> {
        // await coreAPIService.put(
        //     CT_API_ENDPOINT,
        //     `organizations/${orgId}`,
        //     data
        // );
        // console.log('Mock updateOrgDetails:', orgId, data);
        return Promise.resolve();
    }

    async assignManager(data: ManagerAssignmentRequest): Promise<void> {
        // await coreAPIService.post(
        //     CT_API_ENDPOINT,
        //     `organizations/${data.orgId}/assign-manager`,
        //     { managerOrgId: data.managerOrgId }
        // );
        // console.log('Mock assignManager:', data);
        return Promise.resolve();
    }

    // async getManagedOrgs(parentOrgId: string): Promise<OrganizationSummary[]> {
    //     // Mock data
    //     return [
    //         { orgId: 'org-1', orgName: 'Managed Org 1', status: 'active', createdAt: '2023-01-10' },
    //         { orgId: 'org-2', orgName: 'Managed Org 2', status: 'active', createdAt: '2023-02-15' },
    //         { orgId: 'org-3', orgName: 'Managed Org 3', status: 'inactive', createdAt: '2023-03-20' },
    //     ];
    // }

    async checkOrgExists(orgId: string): Promise<boolean> {
        // Mock check: simulate network delay
        await new Promise(resolve => setTimeout(resolve, 500));
        // Simulate that 'existing-org' already exists
        return orgId === 'existing-org';
    }

    async addOrg(orgId: string): Promise<AddOrgResponse> {
        const response = await coreAPIService.post<AddOrgResponse>(
            CTW_API_ENDPOINT,
            'v2/admin/add-org',
            { orgId }
        );
        return response;
    }

    async addUser(data: AddUserRequest): Promise<AddUserResponse> {
        const response = await coreAPIService.post<AddUserResponse>(
            CTW_API_ENDPOINT,
            'v2/admin/add-user',
            data
        );
        return response;
    }

    async fetchUsers(): Promise<FetchUsersResponse> {
        const response = await coreAPIService.post<FetchUsersResponse>(
            CTW_API_ENDPOINT,
            'v2/admin/fetch',
            {}
        );
        return response;
    }

    async updateUserAccess(data: UpdateUserAccessRequest): Promise<UpdateUserAccessResponse> {
        const response = await coreAPIService.post<UpdateUserAccessResponse>(
            CTW_API_ENDPOINT,
            'v2/admin/update-user-access',
            data
        );
        return response;
    }

    async grantAccess(data: GrantAccessRequest): Promise<void> {
        // Mock grant access
        // console.log('Mock grantAccess:', data);
        await new Promise(resolve => setTimeout(resolve, 1000));
        return Promise.resolve();
    }

    async getOrgWabaAccounts(orgId: string): Promise<WabaAccount[]> {
        // Mock WABA accounts
        return [
            { id: 'waba-1', name: 'WABA Account 1', accountId: '123456789', status: 'CONNECTED' },
            { id: 'waba-2', name: 'WABA Account 2', accountId: '987654321', status: 'DISCONNECTED' },
        ];
    }

    async getOrgUsers(orgId: string): Promise<OrgUser[]> {
        const response = await coreAPIService.get<FetchOrgUsersResponse>(
            CTW_API_ENDPOINT,
            `v2/admin/org/${orgId}/users`
        );
        return response.data || [];
    }

    async getWabaDetails(): Promise<WabaDetailsResponse> {
        const response = await coreAPIService.get<WabaDetailsResponse>(
            CTW_API_ENDPOINT,
            'v2/org/waba-details'
        );
        return response;
    }
}

export default new OrgManagementService();
